<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-11 08:54:24
 * @LastEditTime: 2019-10-18 15:29:57
 * @LastEditors: Please set LastEditors
 -->
<template>
    <!-- <div :class="['tree_box', { show: isShow, hide: !isShow }]" ref="treeBox"> -->
    <div :class="['tree_box', { show: isShow }]" ref="treeBox">
        <div
                v-if="loadStyle === 'menuTree'"
                :class="['tree_wrapper', { showShadow: showShadow }]"
                :style="[!isShow && hide, boxWidth]"
                ref="treeWrapper"
        >
            <el-scrollbar style="height:100%">
                <!-- :check-strictly="checkStrictly" -->
                <el-tree
                        highlight-current
                        ref="menuTree"
                        id="taskTreeL"
                        :check-strictly="true"
                        :show-checkbox="showBox"
                        :default-checked-keys="defaultCheckedArray"
                        node-key="expandId"
                        :data="newUserMenus"
                        :default-expand-all="true"
                        :props="defaultStaticProps"
                        :default-expanded-keys="defaultExpandedKeys"
                        @node-click="handleStaticNodeClick"
                        @check-change="handleCheckChange"
                >
          <span class="span-ellipsis" slot-scope="{ node }">
            <span :title="node.label">{{ node.label }}</span>
          </span>
                </el-tree>
            </el-scrollbar>
        </div>
        <div
                v-else-if="loadStyle === 'staticLoad'"
                :class="['tree_wrapper', { showShadow: showShadow }]"
                :style="[!isShow && hide, boxWidth]"
                ref="treeWrapper"
        >
            <el-input
                    v-if="showFilter"
                    v-model="filterStaticText"
                    size="small"
                    placeholder="请输入部门名关键字"
                    suffix-icon="el-icon-search"
                    style="margin-bottom: 10px;"
            ></el-input>
            <el-scrollbar style="height:90%">
                <el-tree
                        highlight-current
                        ref="staticLoad"
                        id="taskTreeL"
                        :check-strictly="false"
                        :show-checkbox="showBox"
                        :filter-node-method="filterStaticNode"
                        :default-checked-keys="defaultCheckedArray"
                        node-key="expandId"
                        :data="TreeData"
                        :props="defaultStaticProps"
                        :default-expanded-keys="defaultExpandedKeys"
                        @node-click="handleStaticNodeClick"
                        @check-change="handleCheckChange"
                >
          <span class="span-ellipsis" slot-scope="{ node }">
            <!-- <div class="top">
          <el-tooltip class="item" effect="dark" :content="node.label" placement="top" :open-delay="0">
		        <span class="span-ellipsis">{{ node.label }}</span>
          </el-tooltip>
        </div> -->
            <span :title="node.label">{{ node.label }}</span>
          </span>
                </el-tree>
            </el-scrollbar>
        </div>

        <!--    //负责人-->
        <div
                v-else-if="loadStyle === 'personCharge'"
                :class="['tree_wrapper', { showShadow: showShadow }]"
                :style="[!isShow && hide, boxWidth]"
                ref="treeWrapper"
        >
            <el-input
                    v-model="filterPersonText"
                    size="small"
                    placeholder="请输入部门名关键字"
                    suffix-icon="el-icon-search"
                    style="margin-bottom: 10px;"
            ></el-input>
            <el-scrollbar style="height:90%">
                <el-tree
                        highlight-current
                        ref="personCharge"
                        id="taskTreeL"
                        :check-strictly="true"
                        :show-checkbox="showBox"
                        :filter-node-method="filterPersonNode"
                        :default-checked-keys="defaultCheckedArray"
                        node-key="expandId"
                        :data="personChargeData"
                        :props="defaultStaticProps"
                        :default-expanded-keys="defaultExpandedKeys"
                        @node-click="handleStaticNodeClick"
                        @check-change="handleCheckChange"
                >
          <span class="span-ellipsis" slot-scope="{ node }">
            <!-- <div class="top">
          <el-tooltip class="item" effect="dark" :content="node.label" placement="top" :open-delay="0">
		        <span class="span-ellipsis">{{ node.label }}</span>
          </el-tooltip>
        </div> -->
            <span :title="node.label">{{ node.label }}</span>
          </span>
                </el-tree>
            </el-scrollbar>
        </div>

        <!--    //体系数-->
        <div
                v-else-if="loadStyle === 'hierarchyTree'"
                :class="['tree_wrapper', { showShadow: showShadow }]"
                :style="[!isShow && hide, boxWidth]"
                ref="treeWrapper"
        >
            <el-input
                    v-model="filterHierarchyTreeText"
                    size="small"
                    placeholder="请输入部门名关键字"
                    suffix-icon="el-icon-search"
                    style="margin-bottom: 10px;"
            ></el-input>
            <el-scrollbar style="height:90%">
                <el-tree
                        highlight-current
                        ref="hierarchyTree"
                        id="taskTreeL"
                        :check-strictly="true"
                        :show-checkbox="showBox"
                        :filter-node-method="filterHierarchyNode"
                        :default-checked-keys="defaultCheckedArray"
                        node-key="expandId"
                        :data="hierarchyTree"
                        :props="defaultHierarchyProps"
                        :default-expanded-keys="defaultExpandedKeysNode"
                        @node-click="handleStaticNodeClick"
                        @check-change="handleCheckChange"
                >
          <span class="span-ellipsis" slot-scope="{ node }">
            <!-- <div class="top">
          <el-tooltip class="item" effect="dark" :content="node.label" placement="top" :open-delay="0">
		        <span class="span-ellipsis">{{ node.label }}</span>
          </el-tooltip>
        </div> -->
            <span :title="node.label">{{ node.label }}</span>
          </span>
                </el-tree>
            </el-scrollbar>
        </div>
        <!--课程里面的树-->
        <div
                v-else-if="loadStyle === 'courseDisabled'"
                :class="['tree_wrapper', { showShadow: showShadow }]"
                :style="[!isShow && hide, boxWidth]"
                ref="treeWrapper"
        >
            <el-input
                    v-model="filterStaticText"
                    size="small"
                    placeholder="请输入部门名关键字"
                    suffix-icon="el-icon-search"
                    style="margin-bottom: 10px;"
            ></el-input>
            <el-scrollbar style="height:90%">
                <el-tree
                        highlight-current
                        ref="courseDisabled"
                        id="taskTreeL"
                        :check-strictly="true"
                        :show-checkbox="showBox"
                        :filter-node-method="filterStaticNode"
                        :default-checked-keys="defaultCheckedArray"
                        node-key="expandId"
                        :data="TreeData"
                        :props="defaultStaticProps"
                        :default-expanded-keys="defaultExpandedKeys"
                        @node-click="handleStaticNodeClick"
                        @check-change="handleCheckChange"
                >
          <span class="span-ellipsis" slot-scope="{ node }">
            <!-- <div class="top">
          <el-tooltip class="item" effect="dark" :content="node.label" placement="top" :open-delay="0">
		        <span class="span-ellipsis">{{ node.label }}</span>
          </el-tooltip>
        </div> -->
            <span :title="node.label">{{ node.label }}</span>
          </span>
                </el-tree>
            </el-scrollbar>
        </div>

        <div
                v-else
                :class="['tree_wrapper', { showShadow: showShadow }]"
                :style="[!isShow && hide, boxWidth]"
                ref="tree"
        >
            <el-input
                    v-model="filterText"
                    size="small"
                    placeholder="请输入部门名关键字"
                    suffix-icon="el-icon-search"
                    style="margin-bottom: 10px;"
            ></el-input>
            <el-scrollbar style="height:90%">
                <div class="tree_wrapper_content">
                    <el-tree
                            accordion
                            id="taskTreeL"
                            :default-expanded-keys="defaultExpandIds"
                            :show-overflow-tooltip="true"
                            :load="loadNode"
                            lazy
                            :highlight-current="true"
                            :props="defaultProps"
                            :filter-node-method="filterNode"
                            node-key="id"
                            empty-text="暂无数据"
                            @node-click="handleNodeClick"
                            @node-expand="expendNodeCollapse"
                            @node-collapse="closeNodeCollapse"
                    >
                        <!-- ref="tree" -->
                        <span class="custom-tree-node" slot-scope="{ node, data }">
              <span :title="node.label">{{ node.label }}</span>
              <span
                      v-if="isEdit"
                      :class="node.level === 1 ? 'groupBtnLeft' : ''"
              >
                <el-button
                        type="text"
                        size="mini"
                        @click.stop="() => append(node, data)"
                >
                  <i class="el-icon-plus"></i>
                </el-button>
                <el-button
                        type="text"
                        size="mini"
                        @click.stop="() => edit(node, data)"
                >
                  <i class="el-icon-edit"></i>
                </el-button>
                <el-button
                        v-if="node.level !== 1"
                        type="text"
                        size="mini"
                        v-popover:data.popoverId
                        @click.stop="() => remove(node, data)"
                >
                  <i class="el-icon-delete"></i>
                </el-button>
                <el-popover
                        ref="data.popoverId"
                        placement="top"
                        width="160"
                        v-model="data.popoverVisible"
                >
                  <p>确定删除吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                            size="mini"
                            type="text"
                            @click.stop="cancelRemove(node, data)"
                    >取消</el-button
                    >
                    <el-button
                            type="primary"
                            size="mini"
                            @click.stop="sureRemove(node, data)"
                    >确定</el-button
                    >
                  </div>
                </el-popover>
              </span>
            </span>
                    </el-tree>
                </div>
            </el-scrollbar>
        </div>
        <div style="display:flex;align-items: center;">
            <div
                    v-if="showArrow"
                    @click="showTree"
                    :class="['arrow-btn', { show: isShow, arrowHide: !isShow }]"
            >
                <i v-if="isShow" class="el-icon-arrow-left"></i>
                <i v-if="!isShow" class="el-icon-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
    // import {getTreeNode} from "@/api/system/role";
    import {mapGetters, mapActions} from "vuex";
    import {tabsList} from '@/api/portrayal/policy'

    export default {
        props: {
            initId: {
                type: String,
                required: false,
                default: 0
            },
            showShadow: {
                type: Boolean,
                required: false,
                default: true
            },
            studentTreeData: {
                type: Boolean,
                required: false,
                default: false
            },
            policyTreeData: {
                type: Boolean,
                required: false,
                default: false
            },
            courseTreeData: {
                type: Boolean,
                required: false,
                default: false
            },
            isEdit: {
                type: Boolean,
                required: false,
                default: true
            },
            showArrow: {
                type: Boolean,
                required: false,
                default: true
            },
            showFilter: {
                type: Boolean,
                required: false,
                default: true
            },
            showBox: {
                type: Boolean,
                required: false,
                default: true
            },
            loadStyle: {
                type: String,
                required: false
            },
            treeWidth: {
                type: String,
                required: false
            },
            courseType: {
                type: Number,
                required: false
            },
            clickedId: {
                type: Object,
                required: false
            },
            clickedIds: {
                type: Object,
                required: false
            },
            checkStrictly: {
                type: Boolean,
                required: false,
                default: true
            },
            isCheckBoxInit: {
                type: Boolean,
                required: false,
            },
        },
        components: {},
        computed: {
            ...mapGetters([
                "chooseDept",
                "chooseDataScopeDept",
                "status",
                "newUserMenus",
                "defaultCheckedArray",
                "studentChooseTree",
                "personChargeData",
                "hierarchyTree"
            ]),
            checkBoxInit: {
                get() {
                    return this.isCheckBoxInit;
                },
                set(val) {
                    this.isCheckBoxInit = val;
                }
            },
            showCheckBox() {
                return eval(this.showBox.toLowerCase());
            },
            boxWidth() {
                return {width: this.treeWidth};
            },
            hide() {
                const hideStyle = {
                    transition: "all 0.2s ease-out",
                    transform: "translate(-" + this.moveDistance + "px, 0)",
                    "-ms-transform":
                        "translate(-" + this.moveDistance + "px, 0)" /* IE 9 */,
                    "-webkit-transform":
                        "translate(-" + this.moveDistance + "px, 0)" /* Safari and Chrome */,
                    "-o-transform":
                        "translate(-" + this.moveDistance + "px, 0)" /* Opera */,
                    "-moz-transform": "translate(-" + this.moveDistance + "px, 0)",
                    display: "none"
                };
                return hideStyle;
            }
        },
        data() {
            return {
                TreeData: [],
                defaultExpandIds: [],
                defaultProps: {
                    label: "label",
                    children: "children",
                    isLeaf: false
                },
                filterText: "",
                filterStaticText: "",
                filterPersonText: "",
                filterHierarchyTreeText: "",
                childData: [],
                nodeData: {},
                isShow: true,
                popoverVisible: false,
                isInit: true,
                defaultStaticProps: {
                    children: "children",
                    label: "name" || "label"
                },
                defaultHierarchyProps: {
                    children: "children",
                    label: "title" || "label"
                },
                defaultExpandedKeys: [],
                defaultExpandedKeysNode: [],
                // checkedArray: [],
                moveDistance: 0
            };
        },
        watch: {
            courseType(newval, oldval) {
                this.TreeDataFun();
            },
            filterText(val) {
                this.$refs.tree.filter(val);
            },
            filterStaticText(val) {
                // console.log(999, val)
                this.$refs.staticLoad.filter(val);
            },
            filterPersonText(val) {
                this.$refs.personCharge.filter(val);
            },
            filterHierarchyTreeText(val) {
                this.$refs.hierarchyTree.filter(val);
            },
            "clickedId.key"(val) {//
                this.$nextTick(() => {
                    this.$refs["staticLoad"].setCurrentKey(this.clickedId.data);
                });
            },
            "clickedIds.key"(val) {//
                this.$nextTick(() => {
                    this.$refs["hierarchyTree"].setCurrentKey(this.clickedIds.data);
                });
            },

            defaultCheckedArray(val) {
                if (
                    val.length === 0 &&
                    this.loadStyle !== "tree" &&
                    this.$refs[this.loadStyle]
                ) {
                    this.$refs[this.loadStyle].setCheckedKeys([]);
                }
            },
            nodeData: {
                handler(newVal, oldVal) {
                    if (
                        newVal &&
                        Object.keys(newVal).length > 0 &&
                        newVal.childNodes.length > 0
                    ) {
                        newVal.childNodes.forEach((child, index) => {
                            if (!child.data.hasChildren) {
                                child.isLeaf = true;
                            }
                        });
                    }
                },
                immediate: true,
                deep: true
            },
            hierarchyTree: {
                handler(newVal, oldVal) {
                    this.generateStaticTree2(newVal);
                },
                immediate: true,
                deep: true
            },
            chooseDept: {

                handler(newVal, oldVal) {
                    this.TreeDataFun();
                    this.generateStaticTree(newVal);
                },
                immediate: true,
                deep: true
            },
            personChargeData: {
                handler(newVal, oldVal) {
                    this.generateStaticTree(newVal);
                },
                immediate: true,
                deep: true
            },
            newUserMenus: {
                handler(newVal, oldVal) {
                    this.generateStaticTree(newVal);
                },
                immediate: true,
                deep: true
            }
        },
        created() {
            this.$store.commit("clearChecked");
            this.$store.commit("clearDefaultChecked");
            this.$store.commit("clearCheckedData");
            this.TreeDataFun();
        },
        methods: {
            ...mapActions(["editNode", "appendNode"]),
            hieCurrentKey(id) {
                this.$nextTick(e => {
                    this.$refs.hierarchyTree.setCurrentKey(id);
                })
            },
            forCancelCourse(treeData) {
                for (let i = 0; i < treeData.length; i++) {
                    treeData[i].disabled = false;
                    if (treeData[i].children.length > 0) {
                        this.forCancelCourse(treeData[i].children);
                    }
                }
            },
            CancelTree() {
                let treeData = JSON.parse(JSON.stringify(this.chooseDept));
                this.forCancelCourse(treeData);
            },
            forEcharCourse(treeData) {
                for (let i = 0; i < treeData.length; i++) {
                    if (treeData[i].orignData.organLevel != this.courseType) {
                        treeData[i].disabled = true;
                    }
                    if (treeData[i].children.length > 0) {
                        this.forEcharCourse(treeData[i].children);
                    }
                }
            },
            TreeDataFun() {
                if (this.studentTreeData) {
                    // console.log(771,this.studentChooseTree);
                    this.TreeData = this.studentChooseTree;
                    // console.log(771,this.studentChooseTree);
                } else if (this.courseTreeData) {
                    let treeData = JSON.parse(JSON.stringify(this.chooseDept));
                    this.forEcharCourse(treeData);
                    this.TreeData = treeData;

                } else if (this.policyTreeData) {
                    this.$store.commit("setTabsData", null);
                    let tabsData = [
                        {
                            name: '全部',
                            id: 0,
                            hasChildren: true,
                            children: []
                        }
                    ]
                    let url = null;
                    // if (this.$route.path == '/policyFile') {
                    //     url = '/admin/dict/type/file_type'
                    // } else {
                    //     url = '/admin/dict/type/file_type_stu'
                    // }
                    url = '/admin/dict/type/policy_type'
                    tabsList(url).then(res => {
                        if (res.data.code == 0) {
                            let data = res.data.data
                            res.data.data.forEach(e => {
                                let o = {
                                    id: Number(e.value),
                                    name: e.label,
                                    hasChildren: true
                                }
                                tabsData[0].children.push(o)
                            })
                            this.TreeData = tabsData;
                            this.$store.commit("setTabsData", tabsData);
                        }
                    })

                } else {
                    this.TreeData = this.chooseDept;
                }
            },
            generateStaticTree(source) {
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            let nodeIsLeaf = item.hasChildren ? true : false;
                            item.label = item.name;
                            item.expandId = item.id;
                            item.isLeaf = nodeIsLeaf;
                            item.popoverId = "popover" + item.id;
                            item.popoverVisible = false;
                            if (
                                item.parentId === 0 &&
                                !this.defaultExpandedKeys.includes(item.expandId)
                            ) {
                                this.defaultExpandedKeys.push(item.expandId);
                            }
                            if (item.children && item.children.length > 0) {
                                filterFun(item.children);
                            }
                        });
                    };
                    filterFun(source);
                    // console.log("source:", source);
                    // this.handleStaticNodeClick(source[0])
                    this.$nextTick(function () {
                        // this.$refs.staticTree.store.nodesMap[source[0].expandId].expanded = true;
                        // console.log("初始化节点：",this.$refs.staticTree.store);
                    });
                } else {
                    return;
                }
            },
            generateStaticTree2(source) {
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            let nodeIsLeaf = item.hasChildren ? true : false;
                            item.label = item.name;
                            item.expandId = item.id;
                            item.isLeaf = nodeIsLeaf;
                            item.popoverId = "popover" + item.id;
                            item.popoverVisible = false;
                            let Hnode = this.$store.getters.defaultHierarchyTree;
                            if (Hnode.length > 0) {
                                this.defaultExpandedKeysNode = Hnode
                            } else {
                                if (
                                    item.level === 1 &&
                                    !this.defaultExpandedKeysNode.includes(item.expandId)
                                ) {
                                    // this.defaultExpandedKeysNode.push(item.expandId);
                                }
                            }
                            if (item.children && item.children.length > 0) {
                                filterFun(item.children);
                            }
                        });
                    };
                    filterFun(source);
                    // console.log("source:", source);
                    // this.handleStaticNodeClick(source[0])
                    this.$nextTick(function () {
                        // this.$refs.staticTree.store.nodesMap[source[0].expandId].expanded = true;
                        // console.log("初始化节点：",this.$refs.staticTree.store);
                    });
                } else {
                    return;
                }
            },
            handleStaticNodeClick(data) {

                //父组件通过@nodeClick自定义事件,获取节点参数data.expendId
                this.$emit("nodeClick", data);
            },
            handleCheckChange(data, checked, indeterminate) {
                // console.log(123,data, this.$refs.menuTree.getCheckedKeys(),checked, indeterminate ,this.checkStrictly)
                // console.log(345,this.checkBoxInit)
                if (checked) {
                    // console.log(this.$refs.staticLoad.getCheckedNodes())
                    this.$emit("BoxClick", "add", this.$refs.staticLoad.getCheckedNodes());
                    // if(data.parentId===-1&&!this.checkBoxInit){
                    //     let recursiveFun=(source)=>{
                    //         source.forEach((item,index)=>{
                    //             this.$nextTick(()=> {
                    //                 console.log("初始化节点：",this.$refs.menuTree.store.nodesMap);
                    //                 this.$refs.menuTree.store.nodesMap[source[0].expandId].checked = true;
                    //             });
                    //             if(item.children.length>0){
                    //                 recursiveFun(item.children);
                    //             }
                    //         })
                    //     }
                    //     recursiveFun([data]);
                    // }else{
                    // console.log(33)
                    // setTimeout(()=>{
                    //     this.checkBoxInit=false;
                    // },100)
                    this.$store.commit("addChecked", data.id);
                    // }
                    this.$store.commit("addCheckedData", data);
                } else {
                    this.$emit("BoxClick", "del", this.$refs.staticLoad.getCheckedNodes());
                    this.$store.commit("deleteChecked", data.id);
                    this.$store.commit("deleteCheckedData", data);
                }
            },
            showTree() {
                this.isShow = !this.isShow;
                const boxWidth = this.$refs.treeBox.clientWidth;
                var wrapperWidth;
                this.moveDistance = this.$refs[this.loadStyle].clientWidth;
                this.$emit("arrowClick", this.isShow);
            },
            handleNodeClick(data, node, msg) {
                // console.log("点击节点数据：", data, node, msg);
                //父组件通过@nodeClick自定义事件,参数data.expendId
                this.$emit("nodeClick", data);
            },
            loadNode(node, resolve) {
                // console.log("--node1--", node);
                this.childData = [];
                const nodeId =
                    node.data === undefined ? Number(this.initId) : node.data.expandId;
                this.getTreeInitData(nodeId).then(res => {
                    // console.log("--res--", res);
                    if (res && res.length > 0) {
                        res.forEach(item => {
                            let nodeIsLeaf = item.hasChildren ? true : false;
                            // console.log(444, nodeIsLeaf);
                            let treeObj = {
                                label: item.title,
                                children: [],
                                expandId: item.id,
                                isLeaf: nodeIsLeaf,
                                hasChildren: item.hasChildren,
                                originData: item.orignData,
                                popoverId: "popover" + item.id,
                                popoverVisible: false
                            };
                            this.childData.push(treeObj);
                        });
                    } else {
                        this.childData = [];
                    }
                    if (node.data !== undefined) {
                        this.childData = [].concat(this.childData, node.data.children);
                        node.data.children = this.childData;
                    }
                    return resolve(this.childData);
                });
            },
            filterFun(source) {
                source.filter((child, index) => {
                    if (child.expanded) {
                        child.expanded = false;
                    }
                    if (child.childNodes && child.childNodes.length > 0) {
                        this.filterFun(child.childNodes);
                    }
                });
            },
            expendNodeCollapse(data, node) {
                this.nodeData = node;
                node.parent.childNodes.filter(child => {
                    if (child.data.expandId !== node.data.expandId) {
                        this.filterFun([child]);
                    }
                });
            },
            closeNodeCollapse(data, node) {
                this.filterFun([node]);
            },
            getTreeInitData(expandId) {
                let self = this;
                return new Promise(function (resolve, reject) {
                    // getTreeNode(`/admin/hierarchy/tree/${expandId}`).then(res => {
                    //     const result = res.data;
                    //     if (result.code == 0) {
                    //         resolve(result.data);
                    //     }
                    // });
                });
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            filterStaticNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },
            filterPersonNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            filterHierarchyNode(value, data) {
                if (!value) return true;
                return data.title.indexOf(value) !== -1;
            },
            append(node, data) {
                this.nodeData = node;
                // console.log("添加時的data:",node, data);
                //父组件提供@appendNode自定义事件,参数data.expendId,调用模态框添加数据，并返回数据给子组件
                // this.$emit("appendNode", node, data);
                const params = {node, data};
                this.appendNode(params).then(res => {
                    // console.log("新增节点信息成功", res);
                });
            },
            setNode(node, data, params) {
                // console.log(4545, node, data, params);
                let newChild = {
                    children: [],
                    expandId: 1,
                    hasChildren: true,
                    isLeaf: true,
                    label: "新增节点",
                    popoverId: "popover" + data.expandId,
                    popoverVisible: false
                };
                if (!data.children) {
                    this.$set(data, "children", []);
                }
                data.children.push(newChild);
                this.$refs.tree.append(newChild, node);
            },
            edit(node, data) {
                const params = {node, data};
                this.editNode(params).then(res => {
                    // console.log("编辑节点信息成功", res);
                });
            },
            remove(node, data) {
                // console.log("刪除時的data:", node, data);
                data.popoverVisible = true;
            },
            cancelRemove(node, data) {
                data.popoverVisible = false;
            },
            sureRemove(node, data) {
                //父组件提供@removeNode自定义事件,参数data.expendId,调用模态框添加数据，并返回数据给子组件
                //this.$emit('removeNode',data);
                const parent = node.parent;
                // console.log(6677, parent, parent.data);
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.expandId === data.expandId);
                children.splice(index, 1);
                const childNodes = parent.childNodes;
                const key = childNodes.findIndex(d => d.data.expandId === data.expandId);
                // console.log(11111, index, key);
                childNodes.splice(key, 1);
                data.popoverVisible = false;
            }
        }
    };
</script>
<style lang="less">
    @import url("index.less");
</style>
